import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Spinner from '../../Spinner';
import { useEffect } from 'react';

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  '& .closeButton': {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const CustomDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <StyledDialogTitle {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className="closeButton"
          onClick={onClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </StyledDialogTitle>
  );
};

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
}));

export default function RemoveDialog(props) {
  const { open, setOpen, removing, removalResults } = props;

  const handleClose = () => {
    setOpen(false);
    props.setRemovalResults([]);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="sm"
    >
      <CustomDialogTitle id="customized-dialog-title" onClose={handleClose}>
        {removing && 'Removing Files...'}
      </CustomDialogTitle>
      <StyledDialogContent dividers>
        {removing && <Spinner />}
        {/* <ul>
                {removalResults.map((result,i) => {
                    return <li key={i}>{result.classNumber} {result.result}</li>;
                })}
            </ul> */}
      </StyledDialogContent>
      {/* <StyledDialogActions>
            {!removing && 
            <Button autoFocus onClick={handleClose} color="primary">
                OK
            </Button>}
        </StyledDialogActions> */}
    </Dialog>
  );
}
